<template>
    <div class="container">
        <section class="vh-100">
            <div class="container-fluid h-custom">
                <div class="row d-flex justify-content-center align-items-center h-100">
                    <div class="col-md-9 col-lg-6 col-xl-5">
                        <h2>Notificación clave</h2>
                        <hr>
                        <br><br>
                        <img src="../../assets/emailClave.png" class="img-fluid" alt="Sample image">
                        <br><br>
                    </div>
                    <div class="col-md-8 col-lg-6 col-xl-4 offset-xl-1" style="background-color: beige; padding: 20px;">
                        <h5>Se envió una clave temporal a la dirección de correo electrónico.</h5>
                        <br><br>
                        <form>
                            <div class="text-center text-lg-start mt-4 pt-2">
                                <button type="button" class="btn btn-primary btn-lg"
                                    style="padding-left: 2.5rem; padding-right: 2.5rem;" @click="salir()">Salir</button>
                            </div>
                        </form>
                        <br><br>
                        <br>
                        <div class="form-outline mb-3">
                            <p class="mensaje">{{ mensaje }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-4 px-4 px-xl-5 bg-primary">
                <!-- Copyright -->
                <div class="text-white mb-3 mb-md-0">
                    Copyright © 2020. All rights reserved.
                </div>
                <!-- Copyright -->
            </div>
        </section>
    </div>
</template>
<script>
export default {
    methods: {
        async salir() {
            this.$router.push('/')
        },
    }
}
</script>